// material-ui
import { createTheme } from '@mui/material/styles';

// third-party
import { presetPalettes } from '@ant-design/colors';

// project import
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  const colors = presetPalettes;

  let greyPrimary = [
    '#426147',    // 0
    '#3a563f',    // 1
    '#324b37',    // 2
    '#2a402f',    // 3
    '#233427',    // 4
    '#1c291f',    // 5
    '#151e17',    // 6
    '#f2edb6',    // 7 - text primary
    '#f0edc9',    // 8 - text secondary
    '#0e130f',    // 9
    '#070907'     // 10
  ];
  
  let greyAscent = [
    '#142b16',    // 11 - background default
    '#1a351c',    // 12
    '#203f22',    // 13
    '#264928'     // 14
  ];
  
  let greyConstant = [
    '#426147',    // 15 - paper
    '#324b37'     // 16
  ];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  // Set primary color with proper shades
  colors.blue = [
    '#e6efe6',    // 0 - lighter
    '#d4e3d4',    // 1
    '#c1d6c2',    // 2
    '#b3ccb4',    // 3
    '#a8c5a9',    // 4
    '#a1c4a2',    // 5 - main
    '#91b092',    // 6
    '#819c82',    // 7
    '#728873',    // 8
    '#637563'     // 9
  ];

  // Add other color arrays to prevent undefined errors
  colors.red = [
    '#ffcdd2',  // lighter
    '#ef9a9a',
    '#e57373',
    '#ef5350',
    '#f44336',
    '#e53935',  // main
    '#d32f2f',
    '#c62828',
    '#b71c1c',  // dark
    '#7f0000'   // darker
  ];

  colors.gold = colors.gold || Array(10).fill('#ffd700');
  colors.cyan = colors.cyan || Array(10).fill('#00ffff');
  colors.green = [
    '#c8e6c9',  // lighter
    '#a5d6a7',
    '#81c784',
    '#66bb6a',
    '#4caf50',
    '#43a047',  // main
    '#388e3c',
    '#2e7d32',
    '#1b5e20',  // dark
    '#003300'   // darker
  ];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode: 'dark',
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700],      // maps to index 7 - #f2edb6
        secondary: paletteColor.grey[8],       // maps to index 8 - #f0edc9
        disabled: paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300],
        disabledBackground: paletteColor.grey[200]
      },
      divider: paletteColor.grey[200],
      background: {
        paper: paletteColor.grey[0],          // maps to first color
        default: paletteColor.grey.A100       // maps to first greyAscent color
      }
    }
  });
}
